module.exports = function() {
  return new Worker(__webpack_public_path__ + "60d00dfeac6d264a22f7.worker.js");
};